import { createContext } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import {
	AuthenticatedTemplate,
	UnauthenticatedTemplate,
	useIsAuthenticated,
	useMsal
} from "@azure/msal-react";
import { FC, ReactNode, useState } from "react";
import { useAsync } from "react-use";
import { useUser } from "src/hooks";
import useSocialProfile from "src/hooks/useSocialProfile/useSocialProfile";
import { SignInScreen } from "src/components/SignInScreen";

export const AuthContext = createContext<{
	user: User | null;

	userRoles: UserRoles;
}>({ user: null, userRoles: [] });

interface Props {
	children?: ReactNode;
}

export const AuthProvider: FC<Props> = ({ children }) => {
	const isAuthenticated = useIsAuthenticated();
	const { inProgress } = useMsal();

	const [user, setUser] = useState<User | null>(null);

	const { refetch: refetchPdtUser } = useUser(undefined, false, {
		enabled: false
	});

	const { data: socialProfile } = useSocialProfile(undefined, {
		enabled: isAuthenticated
	});

	useAsync(async () => {
		if (!isAuthenticated) return;

		const { data: pdtUser } = await refetchPdtUser();
		if (pdtUser) setUser(pdtUser);
	}, [isAuthenticated]);

	if (inProgress === InteractionStatus.Startup) return null;

	return (
		<>
			{socialProfile && socialProfile.user && socialProfile.user.username && (
				<AuthenticatedTemplate>
					<AuthContext.Provider
						value={{ user, userRoles: socialProfile.user.groups }}
					>
						{children}
					</AuthContext.Provider>
				</AuthenticatedTemplate>
			)}

			<UnauthenticatedTemplate>
				<SignInScreen />
			</UnauthenticatedTemplate>
		</>
	);
};

export default AuthContext;
